(function () {
  function initCardGlow() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    const cards = document.querySelectorAll(`
      .product-card,
      .collection-card,
      .resource-card,
      .predictive-search-results__card--product,
      .predictive-search-results__card
    `);

    cards.forEach((card) => {
      if (card.dataset.glowInit) return;
      card.dataset.glowInit = 'true';

      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        card.style.setProperty('--glow-x', `${x}px`);
        card.style.setProperty('--glow-y', `${y}px`);
      });

      card.addEventListener('mouseenter', () => {
        card.style.setProperty('--glow-opacity', '1');
      });

      card.addEventListener('mouseleave', () => {
        card.style.setProperty('--glow-opacity', '0');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initCardGlow);
  document.addEventListener('shopify:section:load', initCardGlow);
})();